import { Injectable, Injector, Type } from '@angular/core';
import { ChatServiceType } from '@nimbus-global/features/chat/models/chat.model';
import { ChatServiceBase } from '@nimbus-global/features/chat/models/chat-service.model';
import { ChatTwilioService } from '@nimbus-global/features/chat/services/twilio/chat-twilio.service';

const SERVICE_MAP: Record<ChatServiceType, Type<ChatServiceBase>> = {
  [ChatServiceType.Whatsapp]: ChatTwilioService,
  [ChatServiceType.Sms]: ChatTwilioService,
  [ChatServiceType.Rcs]: ChatTwilioService,
};

@Injectable({
  providedIn: 'root',
})
export class ChatServiceFactory {
  public createChatService(chatType: ChatServiceType, injector: Injector): ChatServiceBase {
    const serviceClass = SERVICE_MAP[chatType];
    if (!serviceClass) {
      const supported = Object.keys(SERVICE_MAP).join(', ');
      throw new Error(`Unsupported chat type: ${chatType}. Supported: ${supported}`);
    }
    return injector.get(serviceClass);
  }
}
